/* Natugo — armador de pack guiado por pasos, con arrastre a la caja */
(function(){
  var root = document.querySelector('.pkp');
  if(!root) return;

  /* escalones POR MONTO en centavos: "3000000:10,..." → [{min,pct}] */
  var tiers = (root.dataset.tiers||'3000000:10').split(',').map(function(t){
    var a=t.split(':'); return {min:Number(a[0]), pct:Number(a[1])};
  }).sort(function(a,b){ return a.min-b.min; });
  var MAXTIER = tiers[tiers.length-1];

  /* caja móvil flotante */
  var tray      = document.getElementById('pkpTray');
  var trayItems = document.getElementById('pkpTrayItems');
  var trayCount = document.getElementById('pkpTrayCount');
  var trayTotal = document.getElementById('pkpTrayTotal');
  var trayWas   = document.getElementById('pkpTrayWas');
  var trayNote  = document.getElementById('pkpTrayNote');
  var trayAdd   = document.getElementById('pkpTrayAdd');
  var barFill   = document.getElementById('pkpBarFill');

  /* la caja grande del armado */
  var box    = document.getElementById('pkwBox');
  var canvas = document.getElementById('pkwCanvas');
  var empty  = document.getElementById('pkwEmpty');
  var wBar   = document.getElementById('pkwBar');
  var wNote  = document.getElementById('pkwNote');
  var wWas   = document.getElementById('pkwWas');
  var wTotal = document.getElementById('pkwTotal');
  var wCount = document.getElementById('pkwCount');
  var wAdd   = document.getElementById('pkwAdd');

  /* pasos */
  var steps    = Array.prototype.slice.call(document.querySelectorAll('.pkw-step'));
  var panels   = Array.prototype.slice.call(document.querySelectorAll('.pkp-panel'));
  var stepTitle= document.getElementById('pkwStepTitle');
  var skipBtn  = document.getElementById('pkwSkip');
  var nextBtn  = document.getElementById('pkwNext');
  var current  = 0;

  var pack = [];

  function clp(cents){ return '$' + String(Math.round(cents/100)).replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
  function currentTier(total){ var t=null; tiers.forEach(function(x){ if(total>=x.min) t=x; }); return t; }
  function nextTier(total){ for(var i=0;i<tiers.length;i++){ if(total<tiers[i].min) return tiers[i]; } return null; }

  /* ══════════ PASOS ══════════ */
  function goStep(i){
    current = Math.max(0, Math.min(steps.length-1, i));
    steps.forEach(function(s,k){
      s.classList.toggle('on', k===current);
      s.classList.toggle('done', k<current);
    });
    panels.forEach(function(p,k){ p.classList.toggle('on', k===current); });
    if(stepTitle){
      var lbl = steps[current] ? (steps[current].dataset.label || '') : '';
      var art = /s\s*$/i.test(lbl) ? 'tus' : 'tu';
      stepTitle.innerHTML = '<span class="pkw-stepn">Paso '+(current+1)+' · </span>Selecciona '+art+' '+lbl.toLowerCase();
    }
    if(nextBtn){
      nextBtn.textContent = current===steps.length-1 ? '¡Listo! Revisa tu pack 📦' : 'Siguiente paso →';
    }
    if(skipBtn) skipBtn.style.visibility = current===steps.length-1 ? 'hidden' : '';
  }
  steps.forEach(function(s,k){ s.addEventListener('click', function(){ goStep(k); }); });
  if(skipBtn) skipBtn.addEventListener('click', function(){ goStep(current+1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){
    if(current===steps.length-1){
      (box||root).scrollIntoView({behavior:'smooth', block:'center'});
      if(box){ box.classList.add('pkw-box-cheer'); setTimeout(function(){ box.classList.remove('pkw-box-cheer'); },900); }
    } else { goStep(current+1); }
  });

  /* ══════════ RENDER ══════════ */
  function chipFor(it, k, big){
    var chip = document.createElement('div');
    chip.className = big ? 'pkw-chip' : 'pkp-box-chip';
    if(big) chip.style.setProperty('--rot', (it.rot||0)+'deg');
    chip.innerHTML = '<img src="'+(it.img||'')+'" alt="'+it.title+'"><button aria-label="Quitar" type="button">✕</button>';
    chip.querySelector('button').addEventListener('click', function(){ pack.splice(k,1); render(); syncCards(); });
    return chip;
  }

  function render(){
    var n = pack.length, total = 0;
    pack.forEach(function(it){ total += it.price; });

    /* chips: caja grande + caja móvil */
    if(canvas){
      canvas.innerHTML = '';
      if(n===0 && empty){ canvas.appendChild(empty); }
      pack.forEach(function(it,k){ canvas.appendChild(chipFor(it,k,true)); });
    }
    if(trayItems){
      trayItems.innerHTML = '';
      pack.forEach(function(it,k){ trayItems.appendChild(chipFor(it,k,false)); });
    }
    if(tray) tray.hidden = n === 0;

    var tier = currentTier(total), next = nextTier(total);
    var countTxt = n===0 ? 'Tu pack va vacío' : (n===1 ? '1 producto' : n+' productos');
    if(wCount) wCount.textContent = countTxt;
    if(trayCount) trayCount.textContent = countTxt + (n>0?' en tu pack 📦':'');

    var totalTxt, wasTxt='';
    if(tier){ var disc=Math.round(total*tier.pct/100); totalTxt=clp(total-disc); wasTxt=clp(total); }
    else { totalTxt=clp(total); }
    [[wTotal,wWas],[trayTotal,trayWas]].forEach(function(pair){
      if(pair[0]) pair[0].textContent=totalTxt;
      if(pair[1]){ pair[1].textContent=wasTxt; pair[1].style.display=wasTxt?'':'none'; }
    });

    var noteHtml, barPct;
    if(next){
      var faltan=next.min-total;
      noteHtml = tier
        ? '¡'+tier.pct+'% aplicado! Agrega <b>'+clp(faltan)+'</b> y sube a <b>'+next.pct+'%</b>'
        : 'Agrega <b>'+clp(faltan)+'</b> y activa tu <b>'+next.pct+'% de descuento</b>';
      var prevMin = tier?tier.min:0;
      barPct = Math.min(100, Math.round((total-prevMin)/(next.min-prevMin)*100));
    } else { noteHtml='🎉 ¡Máximo descuento! <b>'+MAXTIER.pct+'% aplicado</b>'; barPct=100; }
    if(wNote) wNote.innerHTML=noteHtml;
    if(wBar) wBar.style.width=barPct+'%';
    if(trayNote) trayNote.innerHTML=noteHtml;
    if(barFill) barFill.style.width=barPct+'%';

    if(wAdd) wAdd.disabled = n===0;
    if(trayAdd){ trayAdd.disabled=false; trayAdd.textContent='Agregar mi pack al carro →'; }
  }

  function syncCards(){
    var counts = {};
    pack.forEach(function(p){ var k=p.pid||p.id; counts[k]=(counts[k]||0)+1; });
    document.querySelectorAll('.pkp-pick').forEach(function(c){
      var q = counts[c.dataset.pid]||0;
      c.classList.toggle('in-pack', q>0);
      var b = c.querySelector('.pkp-badge-qty');
      if(q>0){
        if(!b){ b=document.createElement('span'); b.className='pkp-badge-qty'; c.querySelector('.ph').appendChild(b); }
        b.textContent = q;
      } else if(b){ b.remove(); }
    });
  }

  /* ══════════ AGREGAR (toque, botón o arrastre) ══════════ */
  function addItem(card){
    pack.push({
      id: Number(card.dataset.variant),
      pid: card.dataset.pid,
      price: Number(card.dataset.price),
      title: card.dataset.title + (card.dataset.color ? ' · ' + card.dataset.color : ''),
      img: card.dataset.img || (card.querySelector('img')||{}).src,
      rot: (Math.random()*14-7)
    });
    render(); syncCards();
    if(box){ box.classList.remove('pkw-box-pop'); void box.offsetWidth; box.classList.add('pkw-box-pop'); }
    /* avanzar solo al siguiente paso una vez que agregaron un producto */
    if(current < steps.length - 1){
      clearTimeout(autoNext);
      autoNext = setTimeout(function(){ goStep(current + 1); }, 850);
    }
  }
  var autoNext = null;

  function flyToBox(fromRect){
    var target = (box && box.offsetParent) ? box : tray;
    if(!target) return;
    var fly = document.createElement('div');
    fly.className='pkp-fly';
    fly.style.cssText='position:fixed;left:'+fromRect.left+'px;top:'+fromRect.top+'px;width:'+fromRect.width+'px;height:'+fromRect.height+'px;z-index:500;border-radius:14px;pointer-events:none;transition:all .55s cubic-bezier(.5,-0.2,.7,1);overflow:hidden;';
    var img=document.createElement('img');
    img.style.cssText='width:100%;height:100%;object-fit:cover;';
    fly.appendChild(img);
    return {el:fly, img:img, go:function(src){
      img.src=src||''; document.body.appendChild(fly);
      requestAnimationFrame(function(){
        var t=target.getBoundingClientRect();
        fly.style.left=(t.left+t.width/2-18)+'px'; fly.style.top=(t.top+t.height/2-18)+'px';
        fly.style.width='36px'; fly.style.height='36px'; fly.style.opacity='.25';
      });
      setTimeout(function(){ fly.remove(); },560);
    }};
  }

  /* toque + arrastre con Pointer Events (sirve en móvil y desktop) */
  var drag = null;
  document.querySelectorAll('.pkp-pick .ph').forEach(function(ph){
    ph.style.touchAction='none';
    ph.addEventListener('pointerdown', function(e){
      if(e.target.closest('.pkp-sw') || e.target.closest('.pkp-pick-btn')) return;
      var card = ph.closest('.pkp-pick');
      drag = {card:card, ph:ph, x0:e.clientX, y0:e.clientY, moved:false, ghost:null, pid:e.pointerId};
      e.preventDefault();
    });
  });
  document.addEventListener('pointermove', function(e){
    if(!drag || e.pointerId!==drag.pid) return;
    var dx=e.clientX-drag.x0, dy=e.clientY-drag.y0;
    if(!drag.moved && Math.hypot(dx,dy)>8){
      drag.moved=true;
      var img=drag.ph.querySelector('img');
      var g=document.createElement('img');
      g.src=(drag.card.dataset.img||'').replace('width=200','width=300') || (img&&img.src) || '';
      g.className='pkw-ghost';
      document.body.appendChild(g);
      drag.ghost=g;
      if(box) box.classList.add('pkw-box-want');
    }
    if(drag.ghost){
      drag.ghost.style.left=(e.clientX-42)+'px';
      drag.ghost.style.top=(e.clientY-42)+'px';
      if(box){
        var r=box.getBoundingClientRect();
        var over = e.clientX>r.left && e.clientX<r.right && e.clientY>r.top && e.clientY<r.bottom;
        box.classList.toggle('pkw-box-over', over);
      }
    }
  });
  document.addEventListener('pointerup', function(e){
    if(!drag || e.pointerId!==drag.pid) return;
    var d=drag; drag=null;
    if(box){ box.classList.remove('pkw-box-want','pkw-box-over'); }
    if(d.ghost){
      var dropped=false;
      if(box){
        var r=box.getBoundingClientRect();
        dropped = e.clientX>r.left && e.clientX<r.right && e.clientY>r.top && e.clientY<r.bottom;
      }
      if(dropped){
        d.ghost.remove();
        addItem(d.card);
      } else {
        /* no cayó en la caja → vuela igual (toque largo también agrega) */
        var gr=d.ghost.getBoundingClientRect();
        var f=flyToBox(gr); d.ghost.remove();
        if(f){ f.go(d.card.dataset.img); setTimeout(function(){ addItem(d.card); },380); }
        else addItem(d.card);
      }
    } else if(!d.moved){
      /* toque simple sobre la foto → vuela a la caja */
      var pr=d.ph.getBoundingClientRect();
      var f2=flyToBox(pr);
      if(f2){ f2.go(d.card.dataset.img); setTimeout(function(){ addItem(d.card); },380); }
      else addItem(d.card);
    }
  });
  document.addEventListener('pointercancel', function(){ if(drag&&drag.ghost) drag.ghost.remove(); if(box) box.classList.remove('pkw-box-want','pkw-box-over'); drag=null; });

  /* botón ＋ Agregar (fallback accesible) */
  document.querySelectorAll('.pkp-pick .pkp-pick-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var card = btn.closest('.pkp-pick');
      var ph = card.querySelector('.ph');
      var f = ph ? flyToBox(ph.getBoundingClientRect()) : null;
      if(f){ f.go(card.dataset.img); setTimeout(function(){ addItem(card); },380); }
      else addItem(card);
      btn.classList.add('added');
      setTimeout(function(){ btn.classList.remove('added'); },700);
    });
  });

  /* elegir color: actualiza la variante activa de la tarjeta */
  document.querySelectorAll('.pkp-pick .pkp-swatches').forEach(function(sw){
    var card = sw.closest('.pkp-pick');
    sw.querySelectorAll('.pkp-sw').forEach(function(dot){
      dot.addEventListener('click', function(e){
        e.stopPropagation();
        sw.querySelectorAll('.pkp-sw').forEach(function(d){ d.classList.remove('on'); });
        dot.classList.add('on');
        card.dataset.variant = dot.dataset.variant;
        card.dataset.price   = dot.dataset.price;
        card.dataset.img     = dot.dataset.imgSm || dot.dataset.img;
        card.dataset.color   = dot.dataset.color || '';
        var img = card.querySelector('.ph img');
        if(img && dot.dataset.img){ img.src = dot.dataset.img; }
        var pr = card.querySelector('.price');
        if(pr){ pr.textContent = clp(Number(dot.dataset.price)); }
      });
    });
  });

  /* pack ya armado → primero elegir los colores en un popup */
  var rcp      = document.getElementById('rcpModal');
  var rcpTitle = document.getElementById('rcpTitle');
  var rcpBody  = document.getElementById('rcpPieces');
  var rcpAdd   = document.getElementById('rcpAdd');
  var rcpChoice = [];

  function rcpClose(){ if(!rcp) return; rcp.hidden=true; rcp.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  if(rcp){
    rcp.querySelectorAll('[data-rcp-close]').forEach(function(el){ el.addEventListener('click', rcpClose); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !rcp.hidden) rcpClose(); });
  }

  function rcpOpen(card){
    var pieces;
    try{ pieces = JSON.parse(card.dataset.pieces || '[]'); }catch(e){ pieces = []; }
    /* sin datos de color → comportamiento antiguo */
    if(!rcp || !pieces.length){
      var ids=(card.dataset.items||'').split(',').filter(Boolean).map(Number);
      if(ids.length) addRecipe(ids.map(function(id){return {id:id,quantity:1};}), null);
      return;
    }
    rcpTitle.textContent = card.dataset.name || 'Tu pack';
    rcpBody.innerHTML = '';
    rcpChoice = pieces.map(function(p){ return p.opts.length ? p.opts[0].id : p.fallback; });

    pieces.forEach(function(p, idx){
      var wrap=document.createElement('div'); wrap.className='rcp-piece';
      var head=document.createElement('div'); head.className='rcp-piece-head';
      head.innerHTML = '<b>'+p.name+'</b><span class="rcp-chosen"></span>';
      wrap.appendChild(head);
      if(!p.opts.length){
        var note=document.createElement('p'); note.className='rcp-nocolor';
        note.textContent='Incluido — color según disponibilidad';
        wrap.appendChild(note); rcpBody.appendChild(wrap); return;
      }
      var sws=document.createElement('div'); sws.className='rcp-sws';
      p.opts.forEach(function(o,i){
        var b=document.createElement('button'); b.type='button'; b.className='rcp-sw'+(i===0?' on':'');
        b.title=o.c; b.setAttribute('aria-label',o.c);
        b.innerHTML='<img src="'+o.img+'" alt="'+o.c+'" loading="lazy">';
        b.addEventListener('click', function(){
          sws.querySelectorAll('.rcp-sw').forEach(function(x){ x.classList.remove('on'); });
          b.classList.add('on');
          rcpChoice[idx]=o.id;
          head.querySelector('.rcp-chosen').textContent=o.c;
        });
        sws.appendChild(b);
      });
      if(p.opts.length){ head.querySelector('.rcp-chosen').textContent = p.opts[0].c; }
      wrap.appendChild(sws);
      rcpBody.appendChild(wrap);
    });

    rcpAdd.disabled=false; rcpAdd.textContent='Agregar al carro →';
    rcp.hidden=false; rcp.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }

  function addRecipe(items, btn){
    if(btn){ btn.disabled=true; btn.textContent='Agregando…'; }
    window.natugoAddToCart(items)
      .then(function(){ window.location.href = window.Shopify.routes.root + 'cart'; })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent='Reintentar'; } });
  }

  if(rcpAdd) rcpAdd.addEventListener('click', function(){
    var items = rcpChoice.filter(Boolean).map(function(id){ return {id:Number(id), quantity:1}; });
    if(items.length) addRecipe(items, rcpAdd);
  });

  document.querySelectorAll('.pkp-recipe .pkp-add-recipe').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      rcpOpen(btn.closest('.pkp-recipe'));
    });
  });

  /* agregar el pack al carro */
  function addPackToCart(btn){
    if(!pack.length) return;
    var items = pack.map(function(p){ return {id:p.id, quantity:1}; });
    btn.textContent='Agregando…'; btn.disabled=true;
    window.natugoAddToCart(items)
      .then(function(){ window.location.href = window.Shopify.routes.root + 'cart'; })
      .catch(function(){ btn.textContent='Reintentar'; btn.disabled=false; });
  }
  if(trayAdd) trayAdd.addEventListener('click', function(){ addPackToCart(trayAdd); });
  if(wAdd) wAdd.addEventListener('click', function(){ addPackToCart(wAdd); });

  /* flechas del carrusel de packs listos */
  document.querySelectorAll('.pkp-ready .row-nav .ra').forEach(function(b){
    b.addEventListener('click', function(){
      var sc = document.querySelector('.pkp-ready-scroll');
      sc.scrollBy({ left: Number(b.dataset.dir)*sc.clientWidth*0.8, behavior:'smooth' });
    });
  });

  goStep(0);
  render();
})();
